import { useQuery } from "react-query";
import { getAccountTransactionCount } from "../api/transactions/getAccountTransactionCount";
import { getAccountTransactionsCacheKey } from "./transactionsStore";

export const useQueryGetTransactionCount = (accountId: string) => {
  return useQuery(
    [...getAccountTransactionsCacheKey(accountId), "txCount"],
    () => getAccountTransactionCount(accountId),
    { refetchOnWindowFocus: false },
  );
};
